import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { MenuIcon, XIcon } from "lucide-react";
import { Logo } from "./Logo";
import { useAuth } from "../../contexts/AuthContext";
import { mainNavigation } from "../../data/navigation";
export function SiteHeader() {
  const {
    user
  } = useAuth();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  useEffect(() => setOpen(false), [location.pathname, location.hash]);
  const initials = user ? `${user.firstName[0] ?? ""}${user.lastName[0] ?? ""}`.toUpperCase() : "";
  return <header className="sticky top-0 z-40 border-b border-line bg-white/95 backdrop-blur" data-id="element-301" data-mp="g2ng7120m8cq">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-6 px-5 md:h-20 md:px-8" data-id="element-302" data-mp="kyvp3wpmd5bg">
        <Logo data-id="element-303" data-mp="pwnheru6etg6" />

        <nav aria-label="Navigation principale" className="hidden lg:block" data-id="element-304" data-mp="uxuospsepqmb">
          <ul className="flex items-center gap-8" data-id="element-305" data-mp="uy35ytvkbi3b">
            {mainNavigation.map(item => <li key={item.to} data-id="element-306" data-mp="1vj9hj3rf39y">
                <Link to={item.to} className={`text-sm transition-colors duration-150 hover:text-brand ${location.pathname === item.to ? "font-medium text-brand" : "text-muted"}`} data-id="element-307" data-mp="3t0svkzomuxea">
                  {item.label}
                </Link>
              </li>)}
          </ul>
        </nav>

        <div className="flex items-center gap-3" data-id="element-308" data-mp="flmrtyziqcu4">
          {user ? <Link to="/mon-espace" className="hidden items-center gap-2 rounded-full py-1 pl-1 pr-3 text-sm font-medium text-ink transition-colors duration-150 hover:bg-surface sm:flex" data-id="element-309" data-mp="fmen18p7e8jv">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-brand-soft text-xs font-semibold text-brand" data-id="element-310" data-mp="13b7dipn23o73">
                {initials}
              </span>
              Mon espace
            </Link> : <Link to="/connexion" className="hidden whitespace-nowrap text-sm font-medium text-ink transition-colors duration-150 hover:text-brand sm:block" data-id="element-311" data-mp="2ste30o4q1hri">
              Se connecter
            </Link>}
          <Link to="/reservation" className="whitespace-nowrap rounded-full bg-brand px-4 py-2.5 text-sm font-medium text-white transition-colors duration-150 hover:bg-brand-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 md:px-5" data-id="element-312" data-mp="2o1mhis0fa288">
            Prendre RDV
          </Link>
          <button type="button" onClick={() => setOpen(v => !v)} className="flex h-10 w-10 items-center justify-center rounded-full text-ink transition-colors duration-150 hover:bg-surface lg:hidden" aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? "Fermer le menu" : "Ouvrir le menu"} data-id="element-313" data-mp="205i6pkj2drv9">
            {open ? <XIcon className="h-5 w-5" data-id="element-314" data-mp="1ntpk4vfs901x" /> : <MenuIcon className="h-5 w-5" data-id="element-315" data-mp="1iucz8g8h231z" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-316" data-mp="1isiccwdn40v9">
        {open && <motion.nav id="mobile-menu" aria-label="Navigation mobile" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-line bg-white px-5 pb-6 pt-2 lg:hidden" data-id="element-317" data-mp="1xkaqj51p78ve">
            <ul className="divide-y divide-line" data-id="element-318" data-mp="2gimzapop6gqg">
              {mainNavigation.map(item => <li key={item.to} data-id="element-319" data-mp="2biikr57cnw2v">
                  <Link to={item.to} className="block py-3.5 text-base text-ink" data-id="element-320" data-mp="2bjjvf8kgegk2">
                    {item.label}
                  </Link>
                </li>)}
              <li data-id="element-321" data-mp="h5sl06uavsnk">
                <Link to={user ? "/mon-espace" : "/connexion"} className="block py-3.5 text-base font-medium text-brand" data-id="element-322" data-mp="h6k8svhnom3a">
                  {user ? "Mon espace patient" : "Se connecter"}
                </Link>
              </li>
            </ul>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}